import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, getEnv } from 'data_sources/constants';
import { DTBPackage } from 'views/App/Portal/DTB/_types/dtb';

export async function getDTBPackage(orgId: string, dtbPackageId: string, signal?: AbortSignal): Promise<DTBPackage> {
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/packages/${dtbPackageId}`;
  const response = await fetcher({
    method: 'GET',
    url,
    options: { signal },
  });
  return response;
}

export default function useDTBPackage(
  orgId: string,
  dtbPackageId: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  if (!orgId || !dtbPackageId) {
    return {
      data: undefined,
      isFetching: false,
      isError: false,
    };
  }

  return useQuery<DTBPackage, ServerErrorResponse>(
    ['dtbPackage', orgId, dtbPackageId],
    async ({ signal }) => {
      try {
        let data = await getDTBPackage(orgId, dtbPackageId, signal);
        // Remove all mock flag and lock injection logic
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      keepPreviousData: true,
    }
  );
}
